import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const userInfoApi = createApi({
  reducerPath: 'userInfoApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['userInfo'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getUserInfoList: builder.query({
      query: ({ userId }) => ({
        method: 'GET',
        path: `UserProfile/GetInformation/${userId}`,
      }),
      providesTags: ['userInfo'],
    }),
    updateAddress: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'Addresses/UpdateAddress',
      }),
      invalidatesTags: ['userInfo'],
    }),
    updateUserInfo: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'UserProfile/ChangeInformations',
      }),
      invalidatesTags: ['userInfo'],
    }),
    getProfileInfo: builder.query({
      query: () => ({
        method: 'GET',
        path: `UserProfile/GetAllInformation`,
      }),
      providesTags: ['userInfo'],
    }),
    updatePasswordInfo: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: `UserProfile/ChangePassword`,
      }),
      invalidatesTags: ['userInfo'],
    }),
  }),
});

export const userInfoApiReducerName = userInfoApi.reducerPath;
export const userInfoApiReducer = userInfoApi.reducer;
export const userInfoApiMiddleware = userInfoApi.middleware;

export const {
  useGetUserInfoListQuery,
  useUpdateAddressMutation,
  useUpdateUserInfoMutation,
  useGetProfileInfoQuery,
  useUpdatePasswordInfoMutation,
} = userInfoApi;
